<template>
  <div class="company">
    <Header />
    <Nav />
    <div class="company-banner">
      <img src="../assets/company/banner.png" alt="">
    </div>
    <div class="pages">
      <div class="company-menu">
        宏云课堂
        <img src="../assets/icon/right-gray.svg" alt="">
        机构列表
      </div>
      <div class="company-container">
        <div class="left">
          <h4>机构列表</h4>
          <div class="company-list">
            <div class="company-item" @click="godetail">
              <img src="../assets/company/companylist1.png" class="company-item-img" alt="">
              <div class="company-item-content">
                <div class="company-item-title">
                  <h5>光环国际教育集团</h5>
                  <div class="company-item-play">
                    <span>共20门课</span>
                    <img src="../assets/company/play.svg" alt="">
                  </div>
                </div>
                <p>光环国际拥有一支卓越专家顾问团队，他们由具有多年在国内外从事项目管理工作的资深项目经理人组成。分别服务和研究于IT、通信、制造业、工程、电子、能源、金融、政府机构等行业。光环国际一如既往全力推动项目管理在中国的发展，以“诚信，专注，高效，进取，共赢”为理念，为客户创造价值，引领管理实践，提升企业的管理成熟度，帮助企业和管理者实现自我突破和超越！以此推动国家发展！</p>
              </div>
            </div>
            <div class="company-item" @click="godetail">
              <img src="../assets/company/companylist2.png" class="company-item-img" alt="">
              <div class="company-item-content">
                <div class="company-item-title">
                  <h5>民生教育</h5>
                  <div class="company-item-play">
                    <span>共80门课</span>
                    <img src="../assets/company/play.svg" alt="">
                  </div>
                </div>
                <p>民生教育集团有限公司（“民生教育”）在新时代全面实施智慧教育新生态战略，推进“普通高等教育+职业教育”双轮驱动、“校园教育+在线教育”融合发展。民生教育自1998年创立以来，主要在北京、重庆、山东、云南、内蒙古、香港等地和新加坡、澳大利亚等国家举办高等学校和在线教育机构，现有业务覆盖专科、本科和研究生教育、汉语水平考试（HSK）、教师教育等职业培训...</p>
              </div>
            </div>
            <div class="company-item" @click="godetail">
              <img src="../assets/company/companylist3.png" class="company-item-img" alt="">
              <div class="company-item-content">
                <div class="company-item-title">
                  <h5>京东科技</h5>
                  <div class="company-item-play">
                    <span>共90门课</span>
                    <img src="../assets/company/play.svg" alt="">
                  </div>
                </div>
                <p>京东科技经营宗旨是从数据中来，到实体中去，通过数字化手段连接金融与实体产业，助力金融与实体产业实现互联网化、数字化和智能化，进而降低成本、提高效率、提升用户体验和模式升级，在实体经济不断数字化的过程中创造公平与普惠的社会价值。截至目前，公司完成了在数字金融、智能城市、数字农牧、数字营销、数字校园等领域的布局，旗下品牌包括京东金融、京东城市、京东农牧...</p>
              </div>
            </div>
            <div class="company-item" @click="godetail">
              <img src="../assets/company/companylist4.png" class="company-item-img" alt="">
              <div class="company-item-content">
                <div class="company-item-title">
                  <h5>国研智库有限公司</h5>
                  <div class="company-item-play">
                    <span>共60门课</span>
                    <img src="../assets/company/play.svg" alt="">
                  </div>
                </div>
                <p>国研智库论坛自创办以来，成功举办了50余场高端论坛，已成为国内智库领域的标志性论坛，全媒体影响力已位居中国学术领域论坛影响力排行榜前列。  国研智库论坛旨在围绕国务院发展研究中心核心职能，利用中心专家资源及政策解读优势，与社会各界共同搭建政策解读与学术交流平台，从而充分发挥智库作用，推进国家的科学决策、科学发展。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="company-add">
            <img src="../assets/company/add.png" alt="">
            <h4>诚邀讲师加盟入驻</h4>
            <p>51RGB 专业生产高品质课程的在线教育机构，帮助你学软件、设计、创新技能，重建新的就业方向 & 自主创业。我们也提供高品质免费教程 & 免费在线课程。 老师（名师介绍）是来自4A广告,CCTV,IBM等大型互联网公司的在职者，在这里跟你分享高端、前沿、实用的专业知识和经验方法。</p>
            <div class="company-add-btn" @click="goCome">加入我们</div>
          </div>
          <div class="company-hot">
            <div class="company-hot-title">
              <h4>月度热门机构<span>TOP5</span></h4>
              <b>INSTITUTIONS</b>
            </div>
            <ul>
              <li @click="godetail">
                <img src="../assets/icon/top1.png" alt="">
                <img src="../assets/home/companylist1.png" alt="">
                <p>光环国际教育集团</p>
              </li>
              <li @click="godetail">
                <img src="../assets/icon/top2.png" alt="">
                <img src="../assets/home/companylist2.png" alt="">
                <p>民生教育</p>
              </li>
              <li @click="godetail">
                <img src="../assets/icon/top3.png" alt="">
                <img src="../assets/home/companylist3.png" alt="">
                <p>京东科技</p>
              </li>
              <li @click="godetail">
                <b>04</b>
                <img src="../assets/home/companylist4.png" alt="">
                <p>国研智库有限公司</p>
              </li>
              <li @click="godetail">
                <b>05</b>
                <img src="../assets/home/companylist5.png" alt="">
                <p>珀金埃尔默</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Fixed/>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import Fixed from "../components/Fixed.vue";
export default {
  name: "Company",
  components: {
    Header,
    Nav,
    Footer,
    Fixed
  },
  methods: {
    goCome() {
      this.$router.push('/come')
    },
    godetail() {
      this.$router.push('/companyDetail')
    }
  }
};
</script>

<style lang="less" scoped>
.company {
  &-banner {
    width: 100%;
    height: 282px;
    position: relative;
    img {
      height: 282px;
      width: 1920px;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
    }
  }
  &-menu {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
    padding-top: 40px;
    padding-bottom: 20px;
    img {
      margin-left: 4px;
      margin-right: 4px;
    }
  }
  &-container {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .left {
      width: 877px;
      background: #FFFFFF;
      border-radius: 3px;
      border: 1px solid #EEEEEE;
      h4 {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #202429;
      line-height: 64px;
      border-bottom: 1px solid #eee;
      padding-left: 28px;
    }
    }
    .right {
      width: 400px;
    }
  }
  &-list {
    margin: 0 30px;
  }
  &-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
    height: 154px;
    &-img {
      width: 139px;
      height: 92px;
    }
    &-content {
      margin-left: 19px;
      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
        margin-top: 7px;
      }
    }
    &-title {
      display: flex;
      align-content: center;
      justify-content: space-between;
      h5 {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #202429;
        line-height: 25px;
      }
    }
    &-play {
      display: flex;
      align-items: center;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
      }
      img {
        width: 12px;
        height: 12px;
      }
    }
  }
  &-add {
    background: #fff url(../assets/company/addbg.png) no-repeat left top;
    background-size: 100% 118px;
    padding-top: 20px;
    border: 1px solid #eeeeee;
    padding-bottom: 40px;
    border-radius: 6px;
    img {
      width: 375px;
      height: 80px;
      display: block;
      margin: 0 auto;
    }
    h4 {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #3e414d;
      line-height: 25px;
      text-align: center;
      margin-top: 28px;
    }
    p {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #586470;
      line-height: 22px;
      margin-top: 33px;
      padding: 0 24px;
    }
    &-btn {
      width: 146px;
      height: 40px;
      background: linear-gradient(90deg, #fd441f 0%, #e1251b 100%);
      border-radius: 2px;
      border: 1px solid #e1251b;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      margin: 40px auto 0;
    }
  }
  &-hot {
    width: 400px;
    height: 489px;
    background: linear-gradient(
      180deg,
      #fcf8ed 0%,
      #fefbf5 14%,
      #ffffff 23%,
      #ffffff 100%
    );
    border-radius: 4px;
    border: 1px solid #eeeeee;
    margin-top: 20px;
    ul {
      li {
        display: flex;
        align-items: center;
        padding-left: 22px;
        padding-bottom: 23px;
        padding-right: 24px;
        b {
          font-size: 22px;
          font-family: Oswald-Bold, Oswald;
          font-weight: bold;
          color: #888;
          line-height: 34px;
        }
        img:nth-child(1) {
          width: 27px;
          height: 33px;
        }
        img:nth-child(2) {
          height: 60px;
          width: auto;
          margin-left: 8px;
        }
        p {
          font-size: 13px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 23px;
          margin-left: 11px;
          span {
            display: block;
            font-size: 11px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #999999;
            line-height: 16px;
          }
        }
        &:nth-child(1) {
          b {
            color: #fa5055;
          }
        }
        &:nth-child(2) {
          b {
            color: #ff7130;
          }
        }
        &:nth-child(3) {
          b {
            color: #ffb425;
          }
        }
      }
    }
    &-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 28px 36px 34px 27px;
      h4 {
        font-size: 17px;
        font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
        font-weight: 800;
        color: #d1802b;
        line-height: 25px;
        span {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #d1802b;
          line-height: 18px;
          margin-left: 6px;
        }
      }
      b {
        font-size: 17px;
        font-family: Helvetica-BoldOblique, Helvetica;
        font-weight: normal;
        color: #d1802b;
        line-height: 20px;
      }
    }
  }
}
</style>